import React, { useContext } from 'react';

import DatePaginatedTransactionsChannel from '@/channels/DatePaginatedTransactionsChannel';
import PendingTransactionsChannel from '@/channels/PendingTransactionsChannel';
import OperationsLogsList from '@/components/OperationsLogsList';
import PageHeader from '@/components/PageHeader';
import PersonContext from '@/pages/Person/PersonContext';
import DatePaginatedTransactionsList from '@/pages/TransactionList/components/DatePaginatedTransactionsList';
import PendingTransactionsList from '@/pages/TransactionList/components/PendingTransactionsList';
import Container from '@/ui/components/Container';

const TransactionList = () => {
  const {
    person: { id: personId }
  } = useContext(PersonContext);

  return (
    <Container type="page">
      <PageHeader headingText="Transactions" />

      <OperationsLogsList />

      <PendingTransactionsChannel personId={personId}>
        <PendingTransactionsList />
      </PendingTransactionsChannel>
      <hr className="my-4" />
      <DatePaginatedTransactionsChannel personId={personId}>
        <DatePaginatedTransactionsList />
      </DatePaginatedTransactionsChannel>
    </Container>
  );
};

export default TransactionList;
